// extracted by mini-css-extract-plugin
module.exports = {"outsideContainer":"style_outsideContainer__ZDGuW","footer":"style_footer__TIClr","childrenContainer":"style_childrenContainer__0uSH0"};